import { action, computed, observable, reaction, makeObservable } from 'mobx';
import {SuccessResponse, uploadedFiles} from '../../../../domain';
import {Disposers, HttpPromiseState, toastrHelper, toInt} from '../../../../lib/helpers';
import {StaticImageModel} from './models';

export class StaticImageEditStore {
  @observable
  imageUrl: string | null;
  @observable.ref
  imageFile: File | null;
  @observable.ref
  imageUpload: HttpPromiseState<SuccessResponse> | null;

  private readonly disposers = new Disposers();

  constructor() {
    makeObservable(this);
    this.imageUrl = null;
    this.imageFile = null;
    this.imageUpload = null;
    this.setup();
  }

  @action
  handleImageFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files === null || files.length === 0)
      this.imageFile = null;
    else
      this.imageFile = files[0];
  };

  @action
  uploadImage = () => {
    if (this.imageFile === null)
      return;
    if (this.imageUpload?.isPending === true)
      return;
    this.imageUpload = uploadedFiles.uploadImage(this.imageFile);
  };

  @action
  clearImage = () => {
    this.imageUrl = null;
  };

  @action
  sync = (model: StaticImageModel) => {
    this.imageUrl = model.imageUrl;
    this.imageFile = null;
    this.imageUpload = null;
  };

  @computed
  get valid(): boolean {
    return this.imageUrl !== null;
  }

  @computed
  get x9Contents(): string {
    if (this.imageUrl === null)
      return '';
    const model: StaticImageModel = {
      imageUrl: this.imageUrl
    };
    return JSON.stringify(model);
  }

  private setup() {
    this.disposers.add(reaction(
      () => this.imageUpload?.state,
      this.afterImageUploaded));
  }

  @action
  private afterImageUploaded = () => {
    if (this.imageUpload?.isResolved !== true)
      return;
    const results = this.imageUpload.value.Results;
    if (results.Id) {
      // single image uploaded
      const tmp = this.imageUpload.value.Results.Id;
      const id = toInt(tmp);
      if (id === null)
        return;
      this.imageUrl = uploadedFiles.imageUrl(id);
      this.imageUpload = null;
      this.imageFile = null;
    }
    if (results.Error !== null && results.Error !== undefined) {
      toastrHelper.error(results.Error);
    }
  };

  dispose = () => {
    this.disposers.dispose();
  };

}
